import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { LandingLayout } from '@/layout/components/app.landinglayout';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { libbsAuthGuard } from '@/auth/libbs-auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    // MSAL redirect handlers (aceita /auth e /auth/callback)
    {
        path: 'auth',
        component: MsalRedirectComponent,
        pathMatch: 'full'
    },
    { path: 'login', loadComponent: () => import('@/pages/login/login').then((c) => c.LoginComponent) },
    {
        path: 'auth/callback',
        component: MsalRedirectComponent
    },
    {
        path: 'admin',
        component: AppLayout,
        canMatch: [libbsAuthGuard],
        loadChildren: () => import('@/pages/admin/admin.routes'),
        data: { breadcrumb: 'Admin' }
    },
    { path: 'gestor/relacao-material', loadComponent: () => import('@/pages/gestor/relacao-material.component').then((m) => m.RelacaoMaterialComponent) },
    { path: 'gestor/edicao-material', loadComponent: () => import('@/pages/gestor/edicao-material.component').then((m) => m.EdicaoMaterialComponent) },
    // Checkout (público)
    {
        path: 'checkout',
        component: AppLayout,
        canMatch: [libbsAuthGuard],
        children: [
            {
                path: 'address',
                loadComponent: () => import('@/features/pagina-comprador/checkout/checkout-address/checkout-address.component')
                    .then(m => m.CheckoutAddressComponent)
            },
            {
                path: 'summary',
                loadComponent: () => import('@/features/pagina-comprador/checkout/checkout-summary/checkout-summary.component')
                    .then(m => m.CheckoutSummaryComponent)
            },
            {
                path: 'success',
                loadComponent: () => import('@/features/pagina-comprador/checkout/checkout-success/checkout-success.component')
                    .then(m => m.CheckoutSuccessComponent)
            },
            {
                path: 'meus-pedidos',
                loadComponent: () => import('@/features/pagina-comprador/checkout/meus-pedidos/meus-pedidos.component')
                    .then(m => m.MeusPedidosComponent)
            }
        ]
    },
    // Página de detalhe do produto
    //{ path: 'produto/:id', loadComponent: () => import('@/features/pagina-comprador/detalhe-produto.component').then((m) => m.DetalheProdutoComponent) },
    {
        path: 'pagina-comprador',
        component: AppLayout,
        canMatch: [libbsAuthGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('@/features/pagina-comprador/pagina-comprador.component').then((c) => c.PaginaCompradorComponent),
                data: { breadcrumb: 'Início' }
            },
            /*  {
                 path: 'produto/:id',
                 loadComponent: () => import('@/features/pagina-comprador/detalhe-produto.component').then((c) => c.DetalheProdutoComponent),
                 data: { breadcrumb: 'Detalhe do Produto' }
             },
             {
                 path: 'ver-mais',
                 loadComponent: () => import('@/features/pagina-comprador/ver-mais.component').then((c) => c.VerMaisComponent),
                 data: { breadcrumb: 'Catálogo' }
             } */
        ]
    },
    {
        path: 'buyer',
        component: AppLayout,
        canMatch: [libbsAuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full'
            },
            {
                path: 'profile',
                loadComponent: () => import('@/pages/buyer/buyer-profile-component').then((c) => c.BuyerProfileComponent),
                data: { breadcrumb: 'Perfil do Comprador' }
            },
            {
                path: 'home',
                loadComponent: () => import('@/pages/buyer/home').then((c) => c.HomeComponent),
                data: { breadcrumb: 'Home' }
            }
        ]
    },
    {
        path: 'dashboard',
        component: AppLayout,
        canMatch: [libbsAuthGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('@/features/pagina-comprador/pagina-comprador.component').then((c) => c.PaginaCompradorComponent),
                data: { breadcrumb: 'Início' }
            },
            {
                path: 'dashboard-banking',
                loadComponent: () => import('@/pages/dashboards/banking/bankingdashboard').then((c) => c.BankingDashboard),
                data: { breadcrumb: 'Banking Dashboard' }
            },
            {
                path: 'dashboard-marketing',
                loadComponent: () => import('@/pages/dashboards/marketing/marketingdashboard').then((c) => c.MarketingDashboard),
                data: { breadcrumb: 'Marketing Dashboard' }
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadComponent: () => import('@/pages/documentation/documentation').then((c) => c.Documentation)
            },
            {
                path: 'pages',
                loadChildren: () => import('@/pages/pages.routes'),
                data: { breadcrumb: 'Pages' }
            },
            {
                path: 'apps',
                loadChildren: () => import('@/apps/apps.routes'),
                data: { breadcrumb: 'Apps' }
            },

            {
                path: 'blocks',
                data: { breadcrumb: 'Free Blocks' },
                loadChildren: () => import('@/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () => import('@/pages/ecommerce/ecommerce.routes'),
                data: { breadcrumb: 'E-Commerce' }
            },
            {
                path: 'profile',
                loadChildren: () => import('@/pages/usermanagement/usermanagement.routes')
            }
        ]
    },
    {
        path: 'landing',
        component: LandingLayout,
        canMatch: [libbsAuthGuard],
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/landing/landingpage').then((c) => c.LandingPage)
            },
            {
                path: 'features',
                loadComponent: () => import('@/pages/landing/featurespage').then((c) => c.FeaturesPage)
            },
            {
                path: 'pricing',
                loadComponent: () => import('@/pages/landing/pricingpage').then((c) => c.PricingPage)
            },
            {
                path: 'contact',
                loadComponent: () => import('@/pages/landing/contactpage').then((c) => c.ContactPage)
            },
            {
                path: 'cadastro-de-permissao',
                loadComponent: () => import('@/features/permissao/permissao-list/cadastro-de-permissao.component').then((m) => m.CadastroDePermissaoComponent),
                data: { breadcrumb: 'Cadastro de Permissões' }
            },
            //  {
            //     path: 'prototipo-usuario',
            //     loadComponent: () => import('@/features/usuario/usuario-list/usuario-list.component').then((m) => m.UsuarioListComponent),
            //     data: { breadcrumb: 'usuario' }
            // },

            // EDITAR
            {
                path: 'cadastro-de-permissao/:id',
                loadComponent: () => import('@/features/permissao/permissao-detail/editar-permissao.component').then((m) => m.EditarPermissaoComponent),
                data: { breadcrumb: 'Editar Permissão' }
            },
            {
                path: 'listagem-cargos',
                loadComponent: () => import('@/features/cargos/cargo-list/listagem-cargos.component').then((m) => m.ListagemCargosComponent),
                data: { breadcrumb: 'Usuário Cargo' }
            },
            {
                path: 'listagem-material-grupo',
                loadComponent: () => import('@/features/material-grupo/tipo-material-list/listagem-material-grupo.component').then((m) => m.ListagemMaterialGrupoComponent),
                data: { breadcrumb: 'Cadastro de Material' }
            },

            // EDITAR
            {
                path: 'listagem-material-grupo/:id',
                loadComponent: () => import('@/features/material-grupo/tipo-material-detail/editar-material-grupo.component').then((m) => m.EditarMaterialGrupoComponent),
                data: { breadcrumb: 'Editar Material' }
            },

            {
                path: 'importacao-bitlibbs',
                loadComponent: () => import('@/features/gestao-bitlibbs/importacao-bitlibbs-list/importacao-bitlibbs-list.component').then((m) => m.ImportacaoBitLibbsListComponent),
                data: { breadcrumb: 'Importação BitLibbs' }
            },
            {
                path: 'monitor-interface',
                loadComponent: () => import('@/features/monitor-interface/monitor-interface.component').then((m) => m.MonitorInterfaceComponent),
                data: { breadcrumb: 'Monitor Interface' }
            }
            ,
            {
                path: 'monitor-service',
                loadComponent: () => import('@/features/monitor-interface/monitor-service-edit.component').then((m) => m.MonitorServiceEditComponent),
                data: { breadcrumb: 'Monitor Service' }
            }
            ,
            {
                path: 'monitor-integration',
                loadComponent: () => import('@/features/monitor-interface/monitor-integration-detail.component').then((m) => m.MonitorIntegrationDetailComponent),
                data: { breadcrumb: 'Monitor Integration' }
            }
        ]
    },

    { path: 'notfound', component: Notfound },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                loadComponent: () => import('@/pages/auth/login').then((c) => c.Login)
            },
            {
                path: 'register',
                loadComponent: () => import('@/pages/auth/register').then((c) => c.Register)
            },
            {
                path: 'verification',
                loadComponent: () => import('@/pages/auth/verification').then((c) => c.Verification)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('@/pages/auth/forgotpassword').then((c) => c.ForgotPassword)
            },
            {
                path: 'new-password',
                loadComponent: () => import('@/pages/auth/newpassword').then((c) => c.NewPassword)
            },
            {
                path: 'lock-screen',
                loadComponent: () => import('@/pages/auth/lockscreen').then((c) => c.LockScreen)
            },
            {
                path: 'access',
                loadComponent: () => import('@/pages/auth/access').then((c) => c.Access)
            },
            {
                path: 'oops',
                loadComponent: () => import('@/pages/oops/oops').then((c) => c.Oops)
            },
            {
                path: 'error',
                loadComponent: () => import('@/pages/notfound/notfound').then((c) => c.Notfound)
            },
            {
                path: 'sem-permissao',
                loadComponent: () => import('@/pages/pagina-sem-permissao/pagina-sem-permissao.component').then((c) => c.PaginaSemPermissaoComponent)
            },
            {
                path: 'erro',
                loadComponent: () => import('@/pages/pagina-erro/pagina-erro.component').then((c) => c.PaginaErroComponent)
            }
        ]
    },
    { path: '**', redirectTo: '/auth/erro' }
];
